<template>
    <!-- 商品类型选择 -->
    <el-cascader 
    :options="options" 
    :placeholder="inputPlaceholder || $t('app.pleaseSelectProductType')" 
    @change="changeProduct"
    :props="{ checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'name', children: 'childList' }"
    clearable 
    v-model="result" 
    ref="cascader"></el-cascader>
</template>

<script>
import {
  getRecursionDictionaryList,
} from "@/api/SquirrelSettlement";
export default {
    data() {
        return {
            options: [],
            result: []
        };
    },
    props: {
        inputPlaceholder: {
            type: String,
            default: ""
        },
        prop: {
            type: String,
            default: ""
        },
        snFilter: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        // 切换商品类型
        changeProduct(node) {
            let modelParentId = null;
            let modelId = null;
            this.result = [];
            console.log(node, "node");
            if (node.length == 1) {
                modelParentId = node[0];
                this.result = [modelParentId];
            } else if (node.length == 2) {
                modelParentId = node[0];
                modelId = node[1];
                this.result = [modelParentId, modelId];
            }
            console.log(this.result);
            this.$emit("changeP", this.result);
            // this.$emit("input", result);
        },
        initOptions() {
            getRecursionDictionaryList({ typeId: 7003 }).then(ret => {
                if (ret.code === 0) {
                    const data = ret.data || [];
                    this.options = data.map(firstItem => {
                        return {
                            id: firstItem.id,
                            name: firstItem.name,
                            childList: firstItem.childList.map(secondItem => {
                                return {
                                    id: secondItem.id,
                                    name: secondItem.name
                                }
                            })
                        }
                    })
                }
            });
        },
        resetCascaderInput() {
            this.result = [];
        }
    },
    mounted() {
        this.initOptions();
    }
};
</script>

<style lang="scss" scoped></style>